import {
  URL_COMPANY_PREFIX,
  URL_CONTRACTOR_PREFIX,
  URL_EMPLOYEE_PREFIX,
  URL_STAFF_PREFIX,
  URL_TM_PREFIX,
} from "@oysterhr/router"
import { AccountAspectNamespace } from "../types"
import { AccountAspectType } from "./enums"

export const STORED_ASPECT = "selectedAccountAspect"
export const STORED_ASPECT_TYPE = "selectedAccountAspectType"
export const ASPECT_SEARCH_PARAM = "aspect"

export const CompositeIdPrefixForNamespace: Record<AccountAspectNamespace, string> = {
  [URL_COMPANY_PREFIX]: "Company",
  [URL_TM_PREFIX]: "Engagement",
  [URL_EMPLOYEE_PREFIX]: "Engagement",
  [URL_CONTRACTOR_PREFIX]: "Engagement",
  [URL_STAFF_PREFIX]: "",
}

export const NAMESPACES: AccountAspectNamespace[] = [
  URL_COMPANY_PREFIX,
  URL_STAFF_PREFIX,
  URL_TM_PREFIX,
  URL_EMPLOYEE_PREFIX,
  URL_CONTRACTOR_PREFIX,
]

export const FALLBACK_ASPECT = {
  authorizations: { actions: [], fields: [] },
  id: AccountAspectType.NONE,
  type: AccountAspectType.NONE,
  company: null,
}
